import {
  Paper,
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DoneIcon from "@mui/icons-material/Done";
import StepView from "./StepView";
import EquipmentListTables from "./EquipmentListTables";
import TemplatesListTables from "./TemplatesListTables";
import ChecklistDialogCard from "./ChecklistDialogCard";

export default function ChecklistDialog(props) {
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      open={props.isOpen}
      onClose={props.onClose}
    >
      <DialogTitle>
        {props.activeStep}
        <StepView activeStep={props.activeStep} />
      </DialogTitle>
      <DialogContent>
        {/* <DialogContentText>{props.importSubtitle}</DialogContentText> */}

        <Box
          noValidate
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
            width: "100%",
          }}
        >
          <Paper elevation={6} style={{ width: "100%", margin: 10 }}>
            {props.activeStep === 0 ? (
              <EquipmentListTables
                equip={props.equip}
                selectedEquipment={props.selectedEquipment}
                saveSelectedEquip={props.saveSelectedEquip}
              />
            ) : props.activeStep === 1 ? (
              <TemplatesListTables
                array={props.templates}
                selectedTemplates={props.selectedTemplates}
                saveSelectedTemplates={props.saveSelectedTemplates}
              />
            ) : props.activeStep === 2 ? (
              <div>
                <Stack
                  style={{ paddingTop: 10 }}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="primary.main"
                  >
                    {`Clicking "Next" will import ${
                      props.selectedEquipment.length *
                      (props.selectedTemplates.length +
                        props.selectedTemplates.filter(
                          (t) =>
                            t["Checklist Type"] ===
                            "Pre-Functional & Receipt Inspection"
                        ).length)
                    } checklist${
                      props.selectedEquipment.length *
                        (props.selectedTemplates.length +
                          props.selectedTemplates.filter(
                            (t) =>
                              t["Checklist Type"] ===
                              "Pre-Functional & Receipt Inspection"
                          ).length) >
                      1
                        ? "s"
                        : ""
                    }`}
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="primary.main"
                  >
                    {`${
                      props.selectedTemplates.length +
                      props.selectedTemplates.filter(
                        (t) =>
                          t["Checklist Type"] ===
                          "Pre-Functional & Receipt Inspection"
                      ).length
                    } checklist${
                      props.selectedTemplates.length +
                        props.selectedTemplates.filter(
                          (t) =>
                            t["Checklist Type"] ===
                            "Pre-Functional & Receipt Inspection"
                        ).length >
                      1
                        ? "s"
                        : ""
                    } (${
                      props.selectedTemplates.filter((t) =>
                        t["Checklist Type"].includes("Pre-Functional")
                      ).length
                    } Pre-Functional and ${
                      props.selectedTemplates.filter((t) =>
                        t["Checklist Type"].includes("Receipt")
                      ).length
                    } Receipt Inspection${
                      props.selectedTemplates.filter((t) =>
                        t["Checklist Type"].includes("Receipt")
                      ).length === 1
                        ? ""
                        : "s"
                    })`}
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="primary.main"
                  >
                    {`for each of the ${props.selectedEquipment.length} asset${
                      props.selectedEquipment.length > 1 ? "s" : ""
                    } you selected.`}
                  </Typography>
                </Stack>
                <ChecklistDialogCard
                  onChecklistTypeChange={props.onChecklistTypeChange}
                  onChecklistNameChange={props.onChecklistNameChange}
                  onChecklistAssignToChange={props.onChecklistAssignToChange}
                  rows={props.selectedTemplates}
                />
              </div>
            ) : null}
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        {props.importSubtitle !== "Import Successful: Results shown below" && (
          <Button startIcon={<ArrowBackIcon />} onClick={props.onBackClick}>
            {props.activeStep === 0 ? "Cancel" : "Back"}
          </Button>
        )}
        <Button
          disabled={
            props.selectedEquipment.length === 0 ||
            (props.selectedTemplates.length === 0 && props.activeStep === 1)
          }
          startIcon={
            props.activeStep === 2 ? <DoneIcon /> : <ArrowForwardIosIcon />
          }
          variant="contained"
          onClick={props.onNextClick}
        >
          {props.activeStep === 2 ? "Add Checklists" : "Continue"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
